// extracted by mini-css-extract-plugin
export default {"servicesContainer":"OurServices_servicesContainer__a7qIi","divGrid":"OurServices_divGrid__ZbJST","divButton":"OurServices_divButton__CkRoR"};